class AgentGroupModel {
  id;
  name;
  members;

  constructor(options) {
    this.id = options.id;
    this.parentGroupId = options.parentGroupId;
    this.name = options.name;
    this.members = options.members;
  }
}

export default AgentGroupModel;
